export default "<div class=\"o-input-group {{class}}\">\n  {% block content %} {% endblock %}\n</div>\n";